import { RequestTypeEnum } from "@nlc/shared-types";

export const renderRequestDesignType = (
  requestType: RequestTypeEnum,
  designType?: string,
) => {
  const typeLabels = {
    graphic: "Graphic",
    video: "Video",
    website_design: "Website & UI",
    website_implementation: "Website & UI",
  };

  function requestTypeEnumToString(
    type: RequestTypeEnum,
  ): "graphic" | "video" | "website_design" | "website_implementation" {
    switch (type) {
      case RequestTypeEnum.VIDEO: {
        return "video";
      }
      case RequestTypeEnum.WEBSITE_IMPLEMENTATION: {
        return "website_implementation";
      }
      case RequestTypeEnum.WEBSITE_DESIGN: {
        return "website_design";
      }
      case RequestTypeEnum.GRAPHIC: {
        return "graphic";
      }
      default: {
        return "graphic";
      }
    }
  }

  const displayRequestType =
    typeLabels[requestTypeEnumToString(requestType)] ||
    requestType ||
    "Unknown";

  const cleanDesignType =
    designType && designType.trim() ? designType.trim() : null;

  return (
    <div className="py-3 pr-3 min-w-0 w-full line-clamp-3 break-words">
      <div className="font-semibold text-text-primary text-sm">
        {displayRequestType}
      </div>
      {cleanDesignType && (
        <div className="text-text-secondary text-sm font-normal">
          {cleanDesignType}
        </div>
      )}
    </div>
  );
};
